import React from "react";
import Styled from "styled-components";
import Typical from "react-typical";
import { useNavigate } from "react-router-dom";
function HomeCont() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/about");
  };
  return (
    <MainCont>
      <NameCont>
        I'M
        <span style={{ width: "39vw", color: "#ffb400" }}>
          <Typical
            steps={[" Mayank Bhugra.", 3000, " A Web developer.", 2000]}
            loop={Infinity}
            wrapper="span"
          />
        </span>
      </NameCont>
      <P style={{}}>
        I'm an Indian based front-end developer focused on crafting clean &
        user‑friendly experiences, I am passionate about building excellent
        software that improves the lives of those around me.
      </P>
      <BtnCont onClick={handleClick}>
        <Btn>
          More About Me
          <Colapse>
            <i className="fas fa-arrow-right"></i>
          </Colapse>
        </Btn>
      </BtnCont>
    </MainCont>
  );
}

const MainCont = Styled.div`
  height:100vh;
  flex-direction:column;
  display:flex;
  justify-content:center;
  align-items:center;
  width:45vw;
  gap:1rem;
  @media (max-height:768px){
    height:60vh;
    padding-bottom:10vh;
  }
`;
const NameCont = Styled.div`
  font-size:51px;
  color:white;
  text-transform:uppercase;
  font-family:Poppins, sans-serif;
  font-weight:700;
  text-align:left;
  // width:45vw;
  display:block;
  @media (max-width:768px){
    font-size:38px;
    width:100vw;
    text-align:center;
  }
`;
const P = Styled.p`
  color:white;
  line-height:2;
  word-spacing:1px;
  font-size:18px;
  @media (max-width:768px){
    font-size:14px;
    text-align:center;
    width:90vw;
    word-spacing:2px;
    letter-spacing:1px;
  }
`;
const BtnCont = Styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
  width:inherit;
`;
const Colapse = Styled.span`
  border-radius:50%;
  height:50px;
  width:50px;
  z-index:1;
  justify-content:center;
  align-items:center;
  display:flex;
  position:relative;
  color:white;
  background:#ffb400;
  border:1px solid #ffb400;
  margin-left:15px;
  pointer-events:none;
  cursor:pointer;
  @media (max-width:425px){
    width:40px;
    height:40px
  }
`;
const Btn = Styled.button`
  border:2px solid #ffb400;
  border-radius:100px;
  height:3.5rem;
  font-size:20px;
  background:transparent;
  color:white;
  padding-left:1rem;
  padding-right:0;
  font-weight:500;
  z-index:5;
  cursor:pointer;
  display:flex;
  justify-content:space-between;
  align-items:center;
  &:hover{
    transition:1s all;
    background-color:#ffb400;
  }
  @media (max-width:425px){
    font-size:0.84rem;
    height:3rem;
  }
`;
export default HomeCont;
